var _path, _path2, _path3, _path4, _path5, _rect, _circle, _circle2, _circle3, _path6, _path7, _path8, _circle4, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle5, _path18, _path19, _path20, _path21, _circle6, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndrawTeamPageReCffb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "undraw_team_page_re_cffb",
    xmlns: "http://www.w3.org/2000/svg",
    width: 377.88,
    height: 371.655,
    viewBox: "0 0 377.88 371.655",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_309",
    "data-name": "Trazado 309",
    d: "M645.211,212.026a335.626,335.626,0,0,1-2.923,43.14c-.067.5-.139,1-.206,1.507H506.967c-.4-.5-.793-1-1.174-1.507-1.271-1.682-2.463-3.413-3.558-5.2-5.265-8.629-7.71-18.753-5.356-25.761l.042-.109a12.273,12.273,0,0,1,2.372-4.175c5.422-6.172,16.46-5.21,26.5-.309-9.035-9.779-16.254-22.142-16.859-33.21-.593-10.8,5.01-18.541,11.1-25.131.2-.218.4-.43.6-.641.1-.109.2-.212.3-.321,4.75-5.023,10.294-9.979,18.36-9.428,8.847.605,18.693,7.958,25.616,16.551s11.546,18.36,16.23,27.9,9.761,19.3,17.247,27.431c-10.148-12.69-18.354-27.147-21.434-41.234s-.514-27.649,8.429-34.342a21.006,21.006,0,0,1,9.18-3.764c.387-.067.78-.121,1.18-.169,8.309-.992,18.251,1.828,26.735,8.654,9.343,7.516,15.854,18.7,19.122,29.331S645.26,202.114,645.211,212.026Z",
    transform: "translate(-369.987 -142.971)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_310",
    "data-name": "Trazado 310",
    d: "M558.126,309.572h-2.584q-1.235-.762-2.481-1.507c-.514-.321-1.035-.629-1.555-.944q-12.9-7.779-25.954-14.917t-26.215-13.622a1.083,1.083,0,0,1-.629-1.234.311.311,0,0,1,.043-.091c.121-.23.393-.327.793-.133,1.077.533,2.16,1.065,3.237,1.61q13.207,6.59,26.306,13.846t26.033,15.153c.181.109.363.224.545.333C556.486,308.567,557.3,309.07,558.126,309.572Z",
    transform: "translate(-371.053 -195.87)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_311",
    "data-name": "Trazado 311",
    d: "M606.049,268.137h-1.6c-.363-.5-.72-1-1.083-1.507q-12.8-17.737-25.591-35.473-20.95-29.038-41.888-58.075a1.027,1.027,0,0,1-.182-.351c-.121-.43.194-.684.6-.641a1.214,1.214,0,0,1,.847.533q11.746,16.284,23.486,32.557l41.676,57.779c.884,1.222,1.767,2.451,2.65,3.673C605.329,267.132,605.693,267.635,606.049,268.137Z",
    transform: "translate(-385.663 -154.435)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_312",
    "data-name": "Trazado 312",
    d: "M690.231,247.144c-.066,2.693-.23,5.343-.448,7.97q-.063.753-.127,1.507h-1.676c.049-.5.1-1,.139-1.507.333-3.794.563-7.631.575-11.57a161.357,161.357,0,0,0-3.358-32.508A202.521,202.521,0,0,0,675.308,177.3a232.067,232.067,0,0,0-16.284-33.343.893.893,0,0,1-.151-.593c.067-.478.7-.623,1.18-.169a1.389,1.389,0,0,1,.242.3q1.171,1.988,2.3,3.988a231.91,231.91,0,0,1,15.595,33.464,201.576,201.576,0,0,1,9.361,33.791A159.2,159.2,0,0,1,690.231,247.144Z",
    transform: "translate(-434.305 -142.918)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_313",
    "data-name": "Trazado 313",
    d: "M660.372,328.322H293.052a5.281,5.281,0,0,0-5.277,5.277V582.505a5.282,5.282,0,0,0,5.277,5.277h367.32a5.272,5.272,0,0,0,4.012-1.852,1.224,1.224,0,0,0,.115-.145,4.942,4.942,0,0,0,.756-1.277,5.147,5.147,0,0,0,.4-2V333.6A5.283,5.283,0,0,0,660.372,328.322Zm3.776,254.183a3.737,3.737,0,0,1-.624,2.07,3.9,3.9,0,0,1-1.428,1.283,3.743,3.743,0,0,1-1.725.418H293.052a3.775,3.775,0,0,1-3.77-3.77V333.6a3.775,3.775,0,0,1,3.77-3.77h367.32a3.776,3.776,0,0,1,3.776,3.771Z",
    transform: "translate(-287.775 -216.127)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_706",
    "data-name": "Rect\\xE1ngulo 706",
    width: 376.371,
    height: 1.509,
    transform: "translate(0.752 133.344)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_205",
    "data-name": "Elipse 205",
    cx: 4.526,
    cy: 4.526,
    r: 4.526,
    transform: "translate(9.049 118.984)",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_206",
    "data-name": "Elipse 206",
    cx: 4.526,
    cy: 4.526,
    r: 4.526,
    transform: "translate(22.06 118.984)",
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_207",
    "data-name": "Elipse 207",
    cx: 4.526,
    cy: 4.526,
    r: 4.526,
    transform: "translate(35.07 118.984)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_314",
    "data-name": "Trazado 314",
    d: "M560.871,554.663c-4.526-2.946-6.777-9.793-5.668-16.055A19.364,19.364,0,0,1,565.5,524.626a16.126,16.126,0,0,1,15.266,1.085c4.591,2.807,11.085,4.345,13.265,9.962,1.675,4.316-.45,13.082-2.7,17.274-1.949,3.624-5.653,5.281-9.132,6a27.437,27.437,0,0,1-22.19-5.12Z",
    transform: "translate(-393.261 -293.077)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_315",
    "data-name": "Trazado 315",
    d: "M262.987,485.007l-3.619,6.239-.478.823-.7,1.21H247.526l.72-1.21,1.864-3.141,4.345-7.334,4.92,1.967Z",
    transform: "translate(-97.738 -190.162)",
    fill: "#ffb8b8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_316",
    "data-name": "Trazado 316",
    d: "M532.552,625.554l-1.949-1.21-.242-.151,12.23-22.287a8.309,8.309,0,0,1,4.992-4.006,8.214,8.214,0,0,1,4.1-.151,8.08,8.08,0,0,1,2.263.847,7.9,7.9,0,0,1,.841.532,8.078,8.078,0,0,1,2.481,2.8,8.361,8.361,0,0,1-.254,8.442L552.3,617.9l-4.03,6.445-.756,1.21H532.552Z",
    transform: "translate(-383.563 -322.437)",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_208",
    "data-name": "Elipse 208",
    cx: 14.863,
    cy: 14.863,
    r: 14.863,
    transform: "translate(165.548 239.771)",
    fill: "#ffb8b8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_317",
    "data-name": "Trazado 317",
    d: "M588.307,624.372H554.9l.151-.43q-.127-.39-.236-.781c-.079-.272-.145-.551-.206-.823a18.27,18.27,0,0,1,.006-7.685c1.846-9.065,9.21-16.43,9.21-16.43.127-.1.254-.188.381-.278a16.818,16.818,0,0,1,3.54-1.985c5.47-2.269,11.207-1.355,15.062-.181a30.057,30.057,0,0,1,3.927,1.495c.448.212.69.345.69.345l.381,11.625.46,13.918Z",
    transform: "translate(-392.976 -321.255)",
    fill: "#58b957"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_318",
    "data-name": "Trazado 318",
    d: "M622.427,622.193l-2.554-12.986-2.578-13.1a2.735,2.735,0,0,0-2.209-2.16l-5.4-.932-5.023-.865a2.7,2.7,0,0,0-2.608,1,2.668,2.668,0,0,0-.587,1.658,2.735,2.735,0,0,0,.224,1.083c2.62,6.112,2.669,15.788,2,26.3-.03.4-.054.8-.085,1.21h19.056Z",
    transform: "translate(-411.641 -320.286)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_319",
    "data-name": "Trazado 319",
    d: "M560.874,595.522a2.739,2.739,0,0,0-4.327-1.5l-2.318,2.106-9.489,8.641a2.629,2.629,0,0,0-.678.962c-1.071,2.56-3.159,7.613-5.585,13.852q-.59,1.525-1.216,3.141c-.145.4-.3.8-.46,1.21h15.637c.127-.405.254-.811.381-1.21.7-2.2,1.374-4.351,2.027-6.445,1.912-6.082,3.637-11.607,4.968-15.976q.554-1.815,1.011-3.352a2.741,2.741,0,0,0,.048-1.428Z",
    transform: "translate(-386.105 -320.816)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_320",
    "data-name": "Trazado 320",
    d: "M345.6,491.3h1.011l-.139-.339-.369-.871-5.694-13.513-.871.526-7,4.23,3.588,8.756.5,1.21H345.6Z",
    transform: "translate(-131.309 -188.18)",
    fill: "#ffb8b8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_321",
    "data-name": "Trazado 321",
    d: "M621.8,598.271a8.364,8.364,0,0,0-10.475-4.944,7.545,7.545,0,0,0-.769.3,8.258,8.258,0,0,0-3.522,2.983,7.994,7.994,0,0,0-.865,1.676,8.316,8.316,0,0,0,.188,6.4l1.749,3.9,6.257,13.918.545,1.21h12.666l.871-.339,2.263-.871.315-.121Z",
    transform: "translate(-413.28 -320.594)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_322",
    "data-name": "Trazado 322",
    d: "M600.478,529.892a2.459,2.459,0,0,0,2.8-1.061,3.54,3.54,0,0,0,.2-3.112,6.5,6.5,0,0,0-1.934-2.55,7.509,7.509,0,0,0-3.4-1.76,4.515,4.515,0,0,0-3.663.805,3.254,3.254,0,0,0-1.1,3.463,4.8,4.8,0,0,0,2.468,2.421,16.4,16.4,0,0,0,6.68,1.9Z",
    transform: "translate(-408.394 -292.328)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_323",
    "data-name": "Trazado 323",
    d: "M592.023,551.864c-2.389.329-2.083-.887-3.04-3.1s-2.238-4.843-4.64-5.067c-1.968-.184-3.59,1.39-5.184,2.558-2.842,2.083-6.672,3.1-9.966,1.852s-5.583-5.175-4.334-8.47a7.227,7.227,0,0,1,4.179-3.951,14.542,14.542,0,0,1,5.823-.809,30.044,30.044,0,0,1,12.626,3.232c2.706,1.375,5.341,3.342,6.368,6.2s1.7,6.871-1.233,7.644Z",
    transform: "translate(-397.048 -297.675)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_324",
    "data-name": "Trazado 324",
    d: "M602.414,517.608c-1.181-2.056-.206-4.877,1.726-6.25a8.467,8.467,0,0,1,6.831-.957,13.413,13.413,0,0,1,9.622,9.326c.979,3.6.4,7.457,1.225,11.09a14.553,14.553,0,0,0,18.289,10.726c2.482-.729,5-2.5,5.249-5.077a14.232,14.232,0,0,1-8.428,14.25c-3.2,1.334-6.766,1.421-10.23,1.332a18.3,18.3,0,0,1-6.649-1.067,11.9,11.9,0,0,1-6.253-6.78,18.838,18.838,0,0,1-.832-9.34c.341-2.438,1.019-4.827,1.208-7.281a10.106,10.106,0,0,0-1.683-7.016c-1.513-1.942-4.4-2.933-6.554-1.737a15.86,15.86,0,0,1-2.5,1.577c-.939.31-2.271-.235-2.185-1.221Z",
    transform: "translate(-411.552 -287.902)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_325",
    "data-name": "Trazado 325",
    d: "M770.781,617l.115-1.21,3.413-35.51A21.736,21.736,0,0,1,777.9,578c7.026-3.54,13.8-1.846,17.47-.381A19.127,19.127,0,0,1,798.176,579l2,36.8.066,1.21Z",
    transform: "translate(-478.495 -313.887)",
    fill: "#58b957"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_209",
    "data-name": "Elipse 209",
    cx: 14.863,
    cy: 14.863,
    r: 14.863,
    transform: "translate(293.407 227.221)",
    fill: "#ffb8b8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_326",
    "data-name": "Trazado 326",
    d: "M796.871,536.512a8.09,8.09,0,0,0-6.139-13.654,22.8,22.8,0,0,0-5.953,1.527,19.689,19.689,0,0,1-9.25.833,12.35,12.35,0,0,1-7.877-4.651,9.051,9.051,0,0,1-1.113-8.876c1.5-3.282,5-5.09,8.3-6.56a15.168,15.168,0,0,1,4.213-1.384,5.4,5.4,0,0,1,4.191,1.057c.926.8,1.469,1.994,2.477,2.684,1.134.777,2.608.757,3.976.894a15.252,15.252,0,0,1,7.387,27.558Z",
    transform: "translate(-476.542 -285.366)",
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_327",
    "data-name": "Trazado 327",
    d: "M766.43,584.721l-2.215-6.148-.138-.383a1.273,1.273,0,0,0-1.9-.627l-2.515,1.676s-16.127,0-17.422,9.676c-.018.151-.042.321-.06.5a.1.1,0,0,1-.006.024c-.163.635-3.207,12.4-5.821,26.923-.072.4-.145.8-.218,1.21h35.044C772.315,602.985,771.677,589.42,766.43,584.721Z",
    transform: "translate(-464.813 -314.457)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_328",
    "data-name": "Trazado 328",
    d: "M833.014,616.365c-1.912-14.9-4.647-26.947-4.647-26.947-.024-.182-.048-.351-.067-.5-1.289-9.676-17.416-9.676-17.416-9.676l-2.513-1.675a1.273,1.273,0,0,0-1.9.629l-2.354,6.529c-5.247,4.7-5.885,18.264-4.745,32.853h33.8C833.117,617.169,833.063,616.764,833.014,616.365Z",
    transform: "translate(-489.593 -314.458)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_329",
    "data-name": "Trazado 329",
    d: "M377.427,585.347l-3.594,33.924-.127,1.21h-9.724c.115-.393.23-.8.351-1.21,2.759-9.464,6.517-23.28,6.112-26.941a7.164,7.164,0,0,1,3.813-7.619l.278.055Z",
    transform: "translate(-317.866 -317.365)",
    fill: "#58b957"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_210",
    "data-name": "Elipse 210",
    cx: 14.863,
    cy: 14.863,
    r: 14.863,
    transform: "translate(60.382 227.786)",
    fill: "#a0616a"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_330",
    "data-name": "Trazado 330",
    d: "M416.6,610.029a24.369,24.369,0,0,0-1.833,4.333c-.176.533-.345,1.089-.5,1.658-.115.393-.218.8-.321,1.21h-39.2c.055-.4.1-.8.158-1.21,2-15.824,3.625-31.885,3.885-34.505.024-.248.036-.375.036-.375,23.491-12.381,40.635,3.812,40.635,3.812s.024.115.061.339C419.891,587.554,421.8,600.77,416.6,610.029Z",
    transform: "translate(-322.114 -314.113)",
    fill: "#58b957"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_331",
    "data-name": "Trazado 331",
    d: "M439.175,620.085l-2.614-5.6.635-22.221,6.729-1.247.236-.042a17.819,17.819,0,0,1,7.637,8.908c1.307,3.268,3.794,13.1,5.894,21.864.1.405.194.811.29,1.21H440.513l-.563-1.21Z",
    transform: "translate(-346.525 -319.836)",
    fill: "#58b957"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_332",
    "data-name": "Trazado 332",
    d: "M419.776,478.822H333.834a6.962,6.962,0,0,0-6.953,6.953v85.942a6.961,6.961,0,0,0,6.953,6.953h85.942a6.957,6.957,0,0,0,6.953-6.953V485.775A6.957,6.957,0,0,0,419.776,478.822Zm5.743,92.9a5.748,5.748,0,0,1-5.743,5.743H333.834a5.752,5.752,0,0,1-5.743-5.743V485.775a5.752,5.752,0,0,1,5.743-5.743h85.942a5.748,5.748,0,0,1,5.743,5.743Zm-66.336,5.743-.127,1.21h35.988c.1-.411.206-.817.321-1.21Z",
    transform: "translate(-303.217 -275.553)",
    fill: "#3f3d56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_333",
    "data-name": "Trazado 333",
    d: "M610.386,478.822H524.444a6.961,6.961,0,0,0-6.953,6.953v85.942a6.961,6.961,0,0,0,6.953,6.953h85.942a6.958,6.958,0,0,0,6.953-6.953V485.775a6.957,6.957,0,0,0-6.953-6.953Zm5.743,92.9a5.748,5.748,0,0,1-5.743,5.743H524.444a5.752,5.752,0,0,1-5.743-5.743V485.775a5.752,5.752,0,0,1,5.743-5.743h85.942a5.748,5.748,0,0,1,5.743,5.743Zm-75.812,5.743q.109.39.236.781l-.151.43h30.051c.03-.405.055-.811.085-1.21Z",
    transform: "translate(-378.481 -275.553)",
    fill: "#3f3d56"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_334",
    "data-name": "Trazado 334",
    d: "M801.006,478.822H715.064a6.958,6.958,0,0,0-6.953,6.953v85.942a6.957,6.957,0,0,0,6.953,6.953h85.942a6.961,6.961,0,0,0,6.953-6.953V485.775a6.961,6.961,0,0,0-6.953-6.953Zm5.743,92.9a5.751,5.751,0,0,1-5.743,5.743H715.064a5.748,5.748,0,0,1-5.743-5.743V485.775a5.747,5.747,0,0,1,5.743-5.743h85.942a5.751,5.751,0,0,1,5.743,5.743ZM760.2,577.46c-.03.4-.061.8-.091,1.21h26.075c.049-.4.1-.8.151-1.21Z",
    transform: "translate(-453.749 -275.553)",
    fill: "#3f3d56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_335",
    "data-name": "Trazado 335",
    d: "M631.534,695.5h-199.7a4.841,4.841,0,0,1,0-9.682h199.7a4.841,4.841,0,0,1,0,9.682Z",
    transform: "translate(-342.748 -357.289)",
    fill: "#ccc"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_336",
    "data-name": "Trazado 336",
    d: "M612.083,430.5H524.337a4.841,4.841,0,1,1,0-9.682h87.745a4.841,4.841,0,1,1,0,9.682Z",
    transform: "translate(-379.272 -252.651)",
    fill: "#58b957"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_337",
    "data-name": "Trazado 337",
    d: "M406.507,543.294a2.936,2.936,0,0,0,3.84.246,26.1,26.1,0,0,0,8.4-9.771c2.085-4.517,2.318-10.061-.2-14.354-2.125-3.629-5.879-5.972-9.619-7.895a17.108,17.108,0,0,0-4.644-1.79,6.618,6.618,0,0,0-4.812.776A4.156,4.156,0,0,0,397.6,514.8a15.642,15.642,0,0,0-6.676-4.481,8.633,8.633,0,0,0-5.1-.37,8.358,8.358,0,0,0-5.054,5.06,10.12,10.12,0,0,0-.764,5.522,6.745,6.745,0,0,0,2.947,4.62c1.963,1.214,4.466,1.127,6.72.631a56.877,56.877,0,0,1,6.733-1.577c2.3-.218,4.856.355,6.254,2.191a9.548,9.548,0,0,1,1.459,4.593l1.15,8.375a10.215,10.215,0,0,0,.914,3.5,2.018,2.018,0,0,0,.325.435Z",
    transform: "translate(-324.153 -287.696)",
    fill: "#2f2e41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawTeamPageReCffb);
export default __webpack_public_path__ + "static/media/undraw_team_page_re_cffb.d727fa50473e0a9b947473458d3623da.svg";
export { ForwardRef as ReactComponent };